import styled from 'styled-components';
import colors from 'pubweb-smokey/dist/colors';

const PromoStyles = styled.div``;

export default PromoStyles;
